import axios from "./axiosInstance";
import { backendUrl } from "./constants";

export const getNotifications = ({ cursor, limit = 20, unreadOnly } = {}) => {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  if (unreadOnly) params.unreadOnly = "true";
  return axios.get("/notifications", { params }).then((r) => r.data);
};

export const getNotificationCounts = () =>
  axios.get("/notifications/counts").then((r) => r.data);

export const markNotificationsRead = ({ ids, scope, entityId } = {}) =>
  axios.patch("/notifications/read", { ids, scope, entityId }).then((r) => r.data);

export const markNotificationRead = (id) =>
  axios.patch(`/notifications/${id}/read`).then((r) => r.data);

export const markNotificationsSeen = ({ ids, scope } = {}) =>
  axios.patch("/notifications/seen", { ids, scope }).then((r) => r.data);

export const dismissNotification = (id) =>
  axios.delete(`/notifications/${id}`).then((r) => r.data);

/**
 * EventSource cannot send Authorization headers, so the stream is opened
 * with a short-lived single-purpose token exchanged over authenticated REST.
 */
export const getStreamToken = () =>
  axios.post("/notifications/stream-token").then((r) => r.data.token);

export const getStreamUrl = (token) =>
  `${backendUrl}/notifications/stream?token=${encodeURIComponent(token)}`;
